import React from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

const COPY = {
  delete: {
    title: "Delete this message for everyone?",
    body: "The message is removed from public chat for all users immediately and cannot be restored. The report will be marked resolved.",
    action: "Delete message",
    tone: "bg-red-500 hover:bg-red-600",
  },
  dismiss: {
    title: "Dismiss this report?",
    body: "No action will be taken against the author. The report will be closed.",
    action: "Dismiss",
    tone: "bg-slate-900 hover:bg-slate-800",
  },
};

export default function ReportConfirmDialog({ kind, onCancel, onConfirm }) {
  const copy = COPY[kind] || COPY.dismiss;
  return (
    <AlertDialog open={!!kind} onOpenChange={(o) => !o && onCancel()}>
      <AlertDialogContent className="rounded-3xl" data-testid="report-confirm-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-heading font-extrabold">{copy.title}</AlertDialogTitle>
          <AlertDialogDescription>{copy.body}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="rounded-full" data-testid="report-confirm-cancel">
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            data-testid="report-confirm-accept"
            className={`rounded-full ${copy.tone}`}
          >
            {copy.action}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
